module.exports = __webpack_public_path__ + "img/20201221.6fbcea53.png";